import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Chip
} from '@mui/material';
import {
  DescriptionOutlined as DescriptionIcon,
  Print as PrintIcon,
  Article as ArticleIcon
} from '@mui/icons-material';
import api from '../../../api/api';

const ContractPrintDialog = ({ open, onClose, deal, onPrint }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Загрузка шаблонов документов
  useEffect(() => {
    if (!open) return;
    let active = true;
    const loadTemplates = async () => {
    setLoading(true);
    setError('');
    setTemplates([]);
    try {
      const response = await api.get('/documents/templates/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (active) setTemplates(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Ошибка загрузки шаблонов:', error);
      if (active) setError('Ошибка загрузки шаблонов документов');
    } finally {
      if (active) setLoading(false);
    }
    };
    loadTemplates();
    return () => { active = false; };
  }, [open]);

  const handleTemplateSelect = (template) => {
    console.log('🖨️ Выбран шаблон для печати:', template);
    console.log('🖨️ Данные сделки:', deal);
    onPrint(template);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PrintIcon color="primary" />
          <Typography variant="h6">
            Выберите шаблон договора для печати
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        {deal && (
          <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              Информация о сделке:
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Chip 
                label={`№ ${deal.deal_number}`}
                color="primary"
                size="small"
              />
              <Chip 
                label={deal.client?.display_name || deal.client?.name || 'Клиент не указан'}
                color="default"
                size="small"
              />
              <Chip 
                label={`${deal.amount || 0} ₽`}
                color="success"
                size="small"
              />
            </Box>
          </Box>
        )}

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {!loading && !error && templates.length === 0 && (
          <Alert severity="info">
            Шаблоны документов не найдены. Создайте шаблон в разделе "Документы".
          </Alert>
        )}

        {!loading && !error && templates.length > 0 && (
          <List>
            {templates.map((template) => (
              <ListItem key={template.id} disablePadding>
                <ListItemButton 
                  onClick={() => handleTemplateSelect(template)}
                  sx={{ 
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    mb: 1,
                    '&:hover': {
                      bgcolor: 'primary.50'
                    }
                  }}
                >
                  <ListItemIcon>
                    <ArticleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={template.name}
                    secondary={
                      <Box>
                        {template.description && (
                          <Typography variant="body2" color="text.secondary">
                            {template.description}
                          </Typography>
                        )}
                        <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                          <Chip 
                            label={template.category || 'Общий'}
                            size="small"
                            variant="outlined"
                          />
                          <Chip 
                            label={template.created_at && !Number.isNaN(new Date(template.created_at).getTime())
                              ? new Date(template.created_at).toLocaleDateString() : 'Дата не указана'}
                            size="small"
                            variant="outlined"
                          />
                        </Box>
                      </Box>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContractPrintDialog;
